/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Col_ContextInputs */

const en_tasks_col_context = /** @type {(inputs: Tasks_Col_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Context`)
};

const pt_br2_tasks_col_context = /** @type {(inputs: Tasks_Col_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto`)
};

/**
* | output |
* | --- |
* | "Context" |
*
* @param {Tasks_Col_ContextInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_col_context = /** @type {((inputs?: Tasks_Col_ContextInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Col_ContextInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_col_context(inputs)
	return pt_br2_tasks_col_context(inputs)
});